export default "__VITE_ASSET__DFp0YH7Y__"